module.exports = __webpack_public_path__ + "moedc_logo_full-ea6c7451dd7bb48cef9e3fd0e40c3eb9.png";